import React from "react";
import { TableCell, Box } from "@material-ui/core";
import DPHelpTooltip from "Components/DP/DPHelpTooltip/DPHelpTooltip";

export interface DPHeadCellWithTooltipProps {
  label: string;
  content: NonNullable<React.ReactNode>;
  width?: number;
}

const DPHeadCellWithTooltip = (props: DPHeadCellWithTooltipProps) => {
  const { label, content, width } = props;
  return (
    <TableCell>
      <Box  display="flex" whiteSpace="nowrap" alignItems="center">
        {label}
        <DPHelpTooltip
          width={width}
          title={content}
        />
      </Box>
    </TableCell>
  );
};

export default DPHeadCellWithTooltip;
